import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getDefaultGame, getGameById } from "../api/game";
import { getGroupById, postGroup } from "../api/group";
import flechaAvanzar from "../assets/right-arrow.svg";
import oncommit from "../assets/hemmexus.png";
import logoJohnsonAndJohnson from "../assets/logo-jandj.png";
import addIcon from "../assets/register/add-icon.svg";
import icofoto from "../assets/register/ico-foto.svg";
import removeIcon from "../assets/register/remove-icon.svg";
import { setGame, setGroup } from "../redux/actions";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { getGroupId, setGroupId, setGroupTable, updateTimer } from "../utils/helpers";
import { alertError } from "../utils/logger";

function getEmptyGroup() {
	return {
		fullName: "",
		game: null,
		image: "",
		tableNum: "",
		members: [],
	};
}

function Register({ intl }) {
	const [activeGame, setActiveGame] = useState(null);
	const [activeGroup, setActiveGroup] = useState(getEmptyGroup());
	const [actualMember, setActualMember] = useState("");
	const [members, setMembers] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);
	const [loading, setLoading] = useState(false);
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const prevState = useLocation();

	const noTimeScreens = [
		ROUTES.START_GAME,
		ROUTES.START_GAME2,
		ROUTES.START_GAME3,
		ROUTES.START_GAME4,
		ROUTES.START_GAME5,
		ROUTES.END,
		ROUTES.RESULTS,
		ROUTES.GAMEOVER,
	];

	useEffect(() => {
		window.scrollTo(0, 0);
		const asyncFetch = async () => {
			if (prevState?.state?.game) {
				getGameById(prevState.state.game).then((res) => {
					if (res.status === 200) {
						handleData(res.data);
					}
				});
			} else {
				getDefaultGame().then((res) => {
					if (res.status === 200) {
						let defaultGame = res.data;
						handleData(defaultGame);
					}
				});
			}
		};

		asyncFetch();
	}, []);

	function handleData(game) {
		dispatch(setGame(game));
		setActiveGame(game);
		setActiveGroup((prevGroup) => ({
			...prevGroup,
			game: game._id,
		}));
		const groupId = getGroupId();
		if (groupId) {
			getGroupById(groupId)
				.then((res) => {
					if (res.status === 200 && res.data && String(res.data.game) === String(game._id)) {
						reconnect(res.data);
					}
				})
				.catch(() => {});
		}
	}

	function saveGroup(e) {
		e.preventDefault();
		if (loading) return;
		if (!members.length) {
			alertError({
				error: " ",
				customMessage: "¡No has añadido a ningún participante!",
			});
			return;
		}
		setLoading(true);
		activeGroup.members = members;
		postGroup(activeGroup, selectedImage)
			.then((res) => {
				const group = res.data;
				if (res.status === 201) {
					group.time = 0;
					setGroupId(group._id);
					setGroupTable(group.tableNum);
					dispatch(setGroup(group));
					navigate(ROUTES.START_GAME);
				} else {
					setLoading(false);
				}
			})
			.catch((error) => {
				const serverMsg =
					error?.response?.data?.message ||
					error?.response?.data?.error ||
					error?.message;
				alertError({
					error,
					customMessage:
						serverMsg ||
						"No se pudo completar el registro (revisad red y tamaño de la foto).",
					details: selectedImage
						? "Intento con foto: primero /file/single-file, luego POST /group."
						: "Solo POST /group (sin imagen).",
				});
				setLoading(false);
			});
	}

	function reconnect(group) {
		setGroupId(group._id);
		setGroupTable(group.tableNum);
		dispatch(setGroup(group));
		if (group.lastVisited) {
			if (!noTimeScreens.includes(group.lastVisited) && !group.finished)
				updateTimer(group.time);
			navigate(group.lastVisited);
		} else navigate(ROUTES.START_GAME);
	}

	const handleAddMember = () => {
		if (
			members.length < 9 &&
			actualMember.length != 0 &&
			actualMember.length < 45 &&
			actualMember.trim().indexOf(" ") != -1
		) {
			setMembers([...members, actualMember]);
			setActualMember("");
		} else {
			let message =
				actualMember.length >= 45
					? "Nombre demasiado largo"
					: actualMember.trim().indexOf(" ") === -1
					? "¡Cada participante debe tener nombre y apellido!"
					: "Los grupos deben ser de máximo 9 participantes";
			alertError({
				error: " ",
				customMessage: message,
			});
		}
	};

	const handleChange = (element) => (event) => {
		setActiveGroup({ ...activeGroup, [element]: event.target.value });
	};

	function renderMembers() {
		return members.map((name, index) => (
			<div
				key={index}
				className="d-flex justify-content-between align-items-center mt-2 pe-5"
			>
				<div className="ps-3 txt20">{name}</div>
				<img
					src={removeIcon}
					alt=""
					className="btn-remove d-flex align-items-center justify-content-center"
					onClick={() =>
						setMembers(members.filter((member) => member != name))
					}
				/>
			</div>
		));
	}

	return (
		<div className="h-100 bg-notas">
			<div className="d-flex justify-content-between align-items-center legalGebro px-5 pb-3 pt-3">
				<div>
					<img
						style={{ marginLeft: "-10%", "max-width":"150px" }}
						src={oncommit}
						alt="Sinfonía Hemmexus"
						className="img-fluid w-100"
					/>
				</div>
				<div>
					<img
						src={logoJohnsonAndJohnson}
						style={{ maxWidth: "240px" }}
						alt="Johnson & Johnson"
						className="img-fluid"
					/>
				</div>
			</div>
			<div className="container-fluid h-100">
				<div className="row pt-1 d-flex justify-content-between px-5">
					<div className="col-6">
						<div className="title1 mb-1 txtBlue bold txt26" style={{backgroundColor: "#FFFFFFBB", padding: "10px", borderRadius: "10px", width: "fit-content"}}>
							{"Haga una foto de equipo"}
						</div>
						<div className="fotoButton mt-3 image-upload text-center">
							<label htmlFor={"file-input"}>
								<img
									src={
										selectedImage
											? URL.createObjectURL(selectedImage)
											: icofoto
									}
									alt="Haga una foto de equipo"
									className={`img-fluid ${
										selectedImage ? "icofoto-selected" : "icofoto"
									}`}
								/>
							</label>
							<input
								id={"file-input"}
								name={"file-input"}
								type="file"
								accept="image/*"
								onChange={(e) => {
									setSelectedImage(e.target.files[0]);
								}}
							/>
						</div>
					</div>
					<div className="col-6">
						<div className="title1 mb-1 txtBlue bold txt26">
							{"Añada los participantes"}
						</div>
						<div className="container-add">
							<input
								id={`fullName`}
								InputLabelProps={{
									shrink: true,
								}}
								value={actualMember}
								onChange={(event) => {
									setActualMember(event.target.value);
								}}
								autoComplete="off"
								placeholder="Escriba nombre y apellido"
								required
								className="form-control input-add bg-transparent txtBlue"
							/>
							<img
								src={addIcon}
								alt=""
								className="btn-add d-flex align-items-center justify-content-center"
								onClick={handleAddMember}
							/>
						</div>
						<div className="row col-6 mt-3 position-absolute">
							<div className="title1 ms-3 txtBlue bold txt22">
								{"Participantes del grupo"}
							</div>
							{members?.length != 0 ? renderMembers() : <div className="txt20 ms-3 mt-2">Debe añadir algún participante al grupo</div>}
						</div>
					</div>
				</div>
				<div className="row d-flex justify-content-between px-5">
					<div className="mt-3 col-6">
						<div className="title1 txtBlue bold txt26">
								{"Ponga un nombre a su equipo "}
						</div>
						<div className="d-inline-flex title1B txtBlue txt14">
								{"(Máximo 15 caracteres)"}
						</div>
						<input
							id={`fullName`}
							InputLabelProps={{
								shrink: true,
							}}
							autoComplete="off"
							maxLength={15}
							onChange={handleChange("fullName")}
							placeholder="Escriba el nombre"
							required
							className="form-control bg-transparent txtBlue"
						/>
					</div>
					<div
						className="col-5 d-flex justify-content-end align-items-center"
						style={{ marginTop: "9%" }}
					>
						<div className="txt24 txtRed bold me-3">
							Siguiente
						</div>
						<button
							type="button"
							className="btn-main btn-progress border-0"
							onClick={saveGroup}
							disabled={loading}
							data-loading={loading ? "true" : "false"}
							aria-busy={loading}
							aria-label={loading ? "Creando grupo…" : "Siguiente"}
							style={{
								opacity: loading ? 0.65 : 1,
								cursor: loading ? "wait" : "pointer",
								pointerEvents: loading ? "none" : "auto",
							}}
						>
							<img style={{ maxWidth: "50px" }} src={flechaAvanzar} alt="" />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Register);
